import { createContext } from "react";

export const HomepageState = createContext();
HomepageState.displayName = "HomepageState";
